import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelDynamic as _vModelDynamic, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect } from "vue";
const _hoisted_1 = { class: "user_form" };
const _hoisted_2 = /*#__PURE__*/ _createElementVNode("label", { for: "name" }, "Name", -1);
const _hoisted_3 = /*#__PURE__*/ _createElementVNode("label", { for: "email" }, "Email", -1);
const _hoisted_4 = {
    key: 0,
    style: { "color": "red" }
};
const _hoisted_5 = /*#__PURE__*/ _createElementVNode("label", { for: "password" }, "Password", -1);
const _hoisted_6 = { style: { "display": "flex", "align-items": "center" } };
const _hoisted_7 = ["type"];
const _hoisted_8 = {
    key: 0,
    style: { "color": "red" }
};
const _hoisted_9 = /*#__PURE__*/ _createElementVNode("label", { for: "mode" }, "Mode", -1);
const _hoisted_10 = ["value"];
const _hoisted_11 = { style: { "color": "red" } };
const _hoisted_12 = ["disabled"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("form", null, [
            _createElementVNode("div", null, [
                _hoisted_2,
                _withDirectives(_createElementVNode("input", {
                    type: "text",
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.name) = $event))
                }, null, 512), [
                    [_vModelText, _ctx.name]
                ])
            ]),
            _createElementVNode("div", null, [
                _hoisted_3,
                _withDirectives(_createElementVNode("input", {
                    type: "email",
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((_ctx.email) = $event)),
                    required: "required"
                }, null, 512), [
                    [_vModelText, _ctx.email]
                ])
            ]),
            (_ctx.emailError)
                ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(_ctx.emailError), 1))
                : _createCommentVNode("", true),
            _createElementVNode("div", null, [
                _hoisted_5,
                _createElementVNode("div", _hoisted_6, [
                    _withDirectives(_createElementVNode("input", {
                        type: _ctx.passwordVisible ? 'text' : 'password',
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((_ctx.password) = $event)),
                        required: "required"
                    }, null, 8, _hoisted_7), [
                        [_vModelDynamic, _ctx.password]
                    ]),
                    _createElementVNode("button", {
                        class: "btn-show",
                        type: "button",
                        onClick: _cache[3] || (_cache[3] =
                            //@ts-ignore
                            (...args) => (_ctx.togglePasswordVisibility && _ctx.togglePasswordVisibility(...args)))
                    }, _toDisplayString(_ctx.passwordVisible ? 'Hide' : 'Show'), 1)
                ]),
                (_ctx.passwordError)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_8, _toDisplayString(_ctx.passwordError), 1))
                    : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", null, [
                _hoisted_9,
                _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((_ctx.selectedMode) = $event)),
                    class: "form-control",
                    required: "required"
                }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.modeData, (mode, index) => {
                        return (_openBlock(), _createElementBlock("option", {
                            key: index,
                            value: mode
                        }, _toDisplayString(mode), 9, _hoisted_10));
                    }), 128))
                ], 512), [
                    [_vModelSelect, _ctx.selectedMode]
                ])
            ]),
            _createElementVNode("p", _hoisted_11, _toDisplayString(_ctx.message), 1)
        ]),
        _createElementVNode("button", {
            disabled: !_ctx.isFormValid,
            onClick: _cache[5] || (_cache[5] =
                //@ts-ignore
                (...args) => (_ctx.handleSubmit && _ctx.handleSubmit(...args))),
            class: "btn btn-primary btn-block confirm_btn"
        }, " Confirm ", 8, _hoisted_12)
    ]));
}
